// 主数据-外部价格国际化配置文
export default {
  outsidePrice: {
    label: {
      businessDepartmentCode: '部门',
      productName: '商品大类',
      detailProductDisplayName: '产品名称',
      productDetailName: '商品小类',
      externalPriceType: '价格类型',
      productProperty: '产品属性',
      tradeCurrency: '交易货币',
      otherCurrency: '其他货币',
      productStatus: '货物状态',
      tradeMarket: '交易市场',
      startTime: '开始日期',
      endTime: '结束日期',
      showAveragePrice: '显示上述日期范围内均价',
      priceCreateTime: '创建日期',
      priceCreateTimeHn: '价格日期',
      businessDepartmentName: '业务部门',
      priceValue: '价格',
      showName: '显示名称',
      ZHName: '中文名称',
      productCode: '产品编码',
      productStatus_st: '产品状态', // st弹窗表格字段标记
    },
    placeholder: {
      businessDepartmentCode: '请选择部门',
      productName: '请选择商品大类',
      productDetailName: '请选择商品小类',
      startTime: '请选择开始日期',
      endTime: '请选择结束日期',
      detailProductDisplayName: '请输入产品名称',
    },
    message: {
      noData: '没有可使用的数据',
      noSelect: '您还未选择任何数据',
      noPerfect: '请选择所有必选条件',
      noPass: '当前查询结果无法生成均价，请检查查询条件',
      noGetPrice: '当前记录无法生成均价',
    },
    btn: {
      addRecord: '新增记录',
      delRecord: '删除记录',
      save: '保存',
    },
    route: {
      outsidePrice: '外部价格主数据',
    },
  },
};
